import { Button } from "components/ui/button";
import { useSetAtom } from "lib/global-context";
import { currentStepAtom, quizCurrentStepAtom } from "lib/atoms";
import styles from "./restart-button.module.css";

const RestartButton = () => {
  const setCurrentStep = useSetAtom(currentStepAtom);
  const setQuizCurrentStep = useSetAtom(quizCurrentStepAtom);

  return (
    <Button
      onClick={() => {
        setCurrentStep(1);
        setQuizCurrentStep(1);
      }}
      variant={"secondary"}
      size={"sm"}
      className={styles.button}
    >
      Start over
    </Button>
  );
};

export default RestartButton;
